import styled from 'styled-components';

export const HelpText = styled.p`
  font-size: 12.5px;
  font-weight: 500;
`;
